import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M7.575 14.25 14.25 10 7.575 5.75zM10 20a9.7 9.7 0 0 1-3.875-.788 10.1 10.1 0 0 1-3.187-2.15 10.1 10.1 0 0 1-2.15-3.187A9.7 9.7 0 0 1 0 10q0-2.074.788-3.9a10 10 0 0 1 2.15-3.175A10.3 10.3 0 0 1 6.124.788 9.7 9.7 0 0 1 10 0q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 20 10a9.7 9.7 0 0 1-.788 3.875 10.3 10.3 0 0 1-2.137 3.188 10 10 0 0 1-3.175 2.15A9.7 9.7 0 0 1 10 20m0-1.5q3.55 0 6.025-2.488T18.5 10q0-3.55-2.475-6.025T10 1.5q-3.525 0-6.012 2.475Q1.5 6.45 1.5 10q0 3.525 2.488 6.012Q6.475 18.5 10 18.5"
    }, null, -1)
  ]))]))
}
export default { render: render }